var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentHeader',{attrs:{"budget-nav":true,"show-back":false}}),_c('div',{staticClass:"content-container"},[_c('BudgetGrid',{attrs:{"budget-type":"pocm"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }